export default class ItemProjetoPreferencias {
  constructor(
    Titulo, IdModeloAtividade, ModeloAtividade, IdCliente, Cliente, Tags = []
  ) {
    this.Titulo = Titulo;
    this.IdModeloAtividade = IdModeloAtividade;
    this.ModeloAtividade = ModeloAtividade;
    this.IdCliente = IdCliente;
    this.Cliente = Cliente;
    this.Tags = Tags;
  }
}